import { render, staticRenderFns } from "./rental-schedule-limitation-per-week.vue?vue&type=template&id=06ddfa8d&"
import script from "./rental-schedule-limitation-per-week.vue?vue&type=script&lang=js&"
export * from "./rental-schedule-limitation-per-week.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports